import { queryOptions } from '@tanstack/react-query';
import { api as registrationApi } from '@repo/api-kit/registration';
import { searchOrganization } from '#organizations/queries/search-organization';

const { ApiGetFeaturesResponse: ApiGetFeaturesResponseFromJSON } =
  registrationApi.organizations.firstparty.v5;

const all = ['features'] as const;

export const featuresQueries = {
  all,
  detail: (organizationId: string) =>
    queryOptions({
      queryKey: [...all, organizationId] as const,
      queryFn: async () => {
        const graphqlOrg = await searchOrganization({
          includeFinancialDetail: false,
          organizationId,
        });
        return ApiGetFeaturesResponseFromJSON.fromJSON(graphqlOrg.features);
      },
      staleTime: Infinity,
      gcTime: Infinity,
    }),
};
